app.service("filterBox", function(html, loading, productsListConfig, modal) {
	var $filterInput,
		$container,
		$categoryFilter,
		$childrenFilter,
		$priceFrom,
		$priceTo,
		isInitialized,
		config;

	var defaultValues = {
		priceFrom: '',
		priceTo: '',
		filters: []
	};


	function setElements() {
		config=productsListConfig.getData();
		$container = $("#filter-box");
		$categoriesHeader = $('.filter > .filter-name', $container);
		$filterInput = $(".js-filter-checkbox");
		$priceFrom = $("#filter-price-from");
		$priceTo = $("#filter-price-to");
		$categoryFilter = $(".filter-hasSubOptions .js-filter-checkbox");
		$childrenFilter = $(".filter-isSubOption .js-filter-checkbox:enabled");
		$buttons = $("#filter-buttons-bottom");
		$filterLast = $(".filter:last",$container);
	}
	function setEvents() {
		$priceFrom
			.blur(renderButton)
			.keyup(renderButton);

		$priceTo
			.blur(renderButton)
			.keyup(renderButton);

		$container.on('click', '.js-filter-show, .js-filter-hide', function() {
			$(this).closest('.filter').toggleClass('expanded');
		});

		$container.on("click", ".js-set-filters", function(){
			setFilters();
			UA.interaction('Listing - Filtrowanie', 'Filtry', $filterInput.filter(':checked').length);
		});

		$container.on('click', ".js-filter-checkbox", function() {
			renderButton();
			if( $(this).prop('checked') ) {
				var filterName = $.trim($(this).closest('.filter').find('.filter-name').text()).replace(':', '');
				var filterPage = config.title;
				var filterText = $(this).data('name');
				UA.interaction('Listing - Filtrowanie', filterName + ' - ' + filterPage, filterText);
			}
		});

		// na klikniecie kategorii filtra (przedzialu filtrow) czyli item zawierajacego klase filter-hasSubOptions, szukaj wszystkich pozycji rownorzednych az do napotkania item o tej samej klasie
		// (pracujac na kolekcji) znajdz w kazdym znalezionym obiekcie checkboxa i gdy jest aktywny, ustaw jego stan zgodnie z aktualnym stanem kliknietego checkboxa kategorii
		// * skrypt sluzy do przelaczania dzieci danej kategorii lezacych rownorzednie w strukturze DOM
		$categoryFilter.on('click', function() {
			$(this).closest(".filter-hasSubOptions").nextUntil(".filter-hasSubOptions", ".filter-isSubOption").find("input[type='checkbox']").not(':disabled').prop("checked", $(this).is(':checked'));
		});

		$childrenFilter.on('click', function () {
			var $this = $(this);
			var $box = $this.closest('.filter-isSubOption').first();
			var $parent = $box.prevAll('.filter-hasSubOptions').first();
			var $siblings = $parent.nextUntil('.filter-hasSubOptions').not('.filter-deactive');
			$parent.find('input:checkbox').prop('checked', $siblings.length && $siblings.find('input:checkbox:checked').length == $siblings.length);
		});
	}

	// porównuje początkowy stan checkboxów z aktualnym w momencie kliknięcia
	function checkIfCheckboxStateHasChanged() {
		let filterBoxHasChanged = false;

		$filterInput.each(function(index) {
			if ($(this).get(0).checked !== defaultValues.filters[index]) {
				filterBoxHasChanged = true;
				return false; // przerywa pętlę kiedy wykryje zmianę stanu checkboxa
			}
		});

		return filterBoxHasChanged;
	}

	function renderButton() {
		const filterBoxHasChanged = checkIfCheckboxStateHasChanged();

		const showButton =
			filterBoxHasChanged ||
			$priceFrom.val() !== defaultValues.priceFrom ||
			$priceTo.val() !== defaultValues.priceTo;

		if (showButton) {
			html.add('show-filter-button');
		} else {
			html.remove('show-filter-button');
		}
	}

	function setFilters() {
		loading.start();
		$categoryFilter.filter(':checked').each(function () { 
			$(this).closest(".filter-hasSubOptions").nextUntil(".filter-hasSubOptions").find("input[type='checkbox']").prop("checked", false);
		});
		
		var obj = {};
		$(".filter", $container).each(function(i, val) {
			filterName = $(this).data("name");
			obj[filterName] = [];
			$(".filter-typ-checkbox input:checked", this).each(function() {
				obj[filterName].push($(this).val());
			});
		});
		goUrl(obj);
	}
	function goUrl(obj) {
		var urlParams=[];
		var url = getNodeName();
		url += getFilterParams(obj);
		if(config.sortType !== '0'){
			url+=",d" + config.sortType;
		}
		url+=priceFilter();
		url+=".bhtml";
		if (config.promotion !== '') {
			urlParams.push('promocja='+config.promotion);
		}
		if (config.criteria !== '') {
			urlParams.push('criteria='+encodeURIComponent(config.criteria));
		}
		if (config.keyword !== '') {
			urlParams.push('keyword='+encodeURIComponent(config.keyword));
			if (config.searchType !== '') {
				urlParams.push('searchType='+encodeURIComponent(config.searchType));
			}
		}
		if(urlParams.length){
			url+='?'+urlParams.join("&");
		}
		loading.start();
		modal.close();
		$.ajax({
			url: url,
			success: function (html) { 
				loading.stop();
				var href = $('<div>' + html + '</div>').find('link[rel=nice]').attr('href') || url;
				loading.redirect(href);
			},
			error: function () { 
				loading.stop();
				modal.alert('Bład ładowania strony. Odśwież stronę', function () { 
					loading.reload();
				})
			}
		})
		
	}
	function getFilterParams(obj) {
		var tmp = "";
		$.each(obj, function(group, arr) {
			if(arr.length > 0) {
				tmp+=',';
				tmp+=group;
				tmp+=arr.join(':');
			}
		});

		return tmp;
	}
	function getNodeName() {
		return (config.pageUrl !== '/' ? config.pageUrl : "/search"  );
	}
	function priceFilter(){
		var resultUrl='';
		var from=parseInt($priceFrom.val()/1);
		var to=parseInt($priceTo.val()/1);
		if(from>0 || to>0){
			if(from>0 && to>0 && to<from){
				resultUrl+=',od'+to+'do'+from;
			}else{
				resultUrl+=',';
				if(from>0){
					resultUrl+='od'+from;
				}
				if(to>0){
					resultUrl+='do'+to;
				}
			}
		}
		return resultUrl;
	}

	function init() {
		if (isInitialized) return false;
		isInitialized = true;

		setElements();
		setEvents();
		
		defaultValues.priceFrom = $priceFrom.val();
		defaultValues.priceTo = $priceTo.val();
		defaultValues.filters = $filterInput.map((i, f) => $(f).is(':checked'));
	}
	return {
		init: init
	};

});
